import BaseService from '@/services/base.service';
import store from '../store'

const API_URL = process.env.VUE_APP_API_URL;
// const CURRENCY_CODE = process.env.VUE_APP_CURRENCY_CODE;

class TransactionService extends BaseService {
    apiSubmitTransaction(data) {
        return this.post(API_URL + '/api/v2/transact', {
            printable: true,
            bookingCode: '',
            account: store.state.account,
            currency: store.state.currencyCode,
            maxWinnings: '',
            draws: data.draws,
            client_token: '',
            additionalInformation: data.additionalInformation,
            excludeDuplicates: false,
            customer: {
                token: store.state.token
            },
            bets: data.bets
        }).then((response) => {
            const status = response.data.status;
            if (status === 'success') {
                return response.data;
            }
            return response.data;
        }).catch(err => {
            throw err.response.data;
        })
    }

    // bonus: false
    // isDisable: false
    // isSelect: true
    // keyMarket: "832"
    // market: "1 ball"
    // number: 1
    // value: "1-ball"

    apiBookABet(data, amount) {
        return this.post(API_URL + '/api/v2/book-a-bet',
            {
                items: data,
                account: store.state.account,
                currency: store.state.currencyCode,
                amount
            })
            .then((response) => {
            const status = response.data.status;
            if (status === 'success') {
                return response.data;
            }
            return response.data;
        }).catch(err => {
            throw err.response.data;
        })
    }

    apiBookedBet(code) {
        return this.post(API_URL + '/api/v2/booked-bet',
            {
                code,
                account: store.state.account,
                type: 'Single',
            })
            .then((response) => {
                const status = response.data.status;
                if (status === 'success') {
                    return response.data;
                }
                return response.data;
            }).catch(err => {
                throw err.response.data;
            })
    }
}

export default new TransactionService();
